export default (state, { payload: { failedActionType, ...rest } }) => ({
  ...state,
  persistentErrors: [
    ...state.persistentErrors,
    {
      type: failedActionType,
      payload: { ...rest }
    }
  ]
});
